import React from "react";
import {SiUbereats} from "react-icons/si";

export default function ButtonUberComponent() {
    return (
        <a
            className="bg-black flex items-center justify-center w-[60px] h-[40px] rounded-lg"
            href="https://www.ubereats.com/fr/store/o-jardin-secret/WI1LazKMTamLSS9yGvZ1_Q"
            target="_blank"
            rel="noreferrer"
        >
            <SiUbereats/>
        </a>
    );
}
